import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-87256014"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "sub-competency__abbreviation" }

import { nextTick, ref, watch } from "vue";
  
  import GenericAccordion from "vue/applications/frontend/components/generic-accordion.vue";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'competency-accordion',
  props: {
    competency: {
      type: Object,
      default: null,
    } 
  },
  setup(__props) {

  

  const competency = ref({jump_target: false});
  const scroll = ref<HTMLElement | null>(null);

  watch(() => competency.value.jump_target, (newValue) => {
    if (newValue) {
      nextTick().then(() => {
        const element = scroll.value;
        if(element){
          // This is a hack because directly executing won't work
          setTimeout(() => {
            element.scrollIntoView();
            competency.value.jump_target = false;
          }, 200);
        }
      }); 
    }
  }, { immediate: true });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "scroll",
    ref: scroll,
    class: "components__competency-accordion"
  }, [
    (competency.value)
      ? (_openBlock(), _createBlock(GenericAccordion, {
          key: 0,
          modelValue: competency.value.expanded,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((competency.value.expanded) = $event))
        }, {
          header: _withCtx(() => [
            _createElementVNode("h2", null, _toDisplayString(competency.value.abbreviation) + " - " + _toDisplayString(competency.value.name), 1)
          ]),
          content: _withCtx(() => [
            (competency.value.descriptions.length > 0)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(competency.value.descriptions, (description, index) => {
                    return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(description), 1))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(competency.value.sub_competencies, (sub_competency) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["sub-competency", {highlight: sub_competency.highlighted}]),
                key: sub_competency.id
              }, [
                _createElementVNode("div", _hoisted_2, _toDisplayString(sub_competency.abbreviation) + ":", 1),
                _createElementVNode("div", null, _toDisplayString(sub_competency.description), 1)
              ], 2))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ], 512))
}
}

})